import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FiltersStateSped } from "./type";



const initialState: FiltersStateSped = {
  fromDate: null,
  toDate: null,
};

const filtersSliceSped = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFromDate(state, action: PayloadAction<Date | null>) {
      state.fromDate = action.payload;
    },
    setToDate(state, action: PayloadAction<Date | null>) {
      state.toDate = action.payload;
    },
  },
});

export const { setFromDate, setToDate } = filtersSliceSped.actions;

export default filtersSliceSped.reducer;
